export const environment = {
  production: false,
  googleAnayticTag: 'G-MX82ZEPQ8W',
  samlApp: 'compass-stg',
  appConfig: {
    environment: 'STG',
    useLiveReload: false,
    useLocalHost: false,
    useExternalLocalHost: false,
    externalHost: null
  },
  firebase: {
    apiKey: "AIzaSyC6GTMSH96sArL_Cq-6-AUG5pf6UFO8ilA",
    authDomain: "ceterisparibus-150323.firebaseapp.com",
    databaseURL: "https://ceterisparibus-150323.firebaseio.com",
    projectId: "ceterisparibus-150323",
    storageBucket: "ceterisparibus-150323.appspot.com",
    messagingSenderId: "5360163219",
    appId: "1:5360163219:web:652d02bb773d72dee57066"
  }
};
